import { Flex, Image } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';

import { EndOfFlowDesktopAnimation, EndOfFlowMobileAnimation } from '../../assets/Images';

const END_OF_FLOW_ANIMATION_MS = 18000;

type EndOfFlowAnimationProps = {
  importInfoDone: boolean;
  onNext: () => void;
};

const EndOfFlowAnimation = ({ importInfoDone, onNext }: EndOfFlowAnimationProps) => {
  const [timerDone, setTimerDone] = useState(false);
  const hasAutoNavigated = useRef(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimerDone(true);
    }, END_OF_FLOW_ANIMATION_MS);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (timerDone && importInfoDone && !hasAutoNavigated.current) {
      hasAutoNavigated.current = true;
      onNext();
    }
  }, [timerDone, importInfoDone]);

  return (
    <Flex flexDir="column" alignItems="center">
      <Image
        src={EndOfFlowDesktopAnimation}
        display={{ base: 'none', md: 'block' }}
        maxW="1000px"
        mb={10}
      />
      <Image
        src={EndOfFlowMobileAnimation}
        display={{ base: 'block', md: 'none' }}
        maxW="400px"
        mb={4}
      />
    </Flex>
  );
};

export default EndOfFlowAnimation;
